import AdminSisSyncPausedView from './AdminSisSyncPausedView';

export default AdminSisSyncPausedView;
